import React from 'react'
import "./ProjectDetails.css"
import { Link } from 'react-router-dom'
import marie from "../Assets/mariemadeit.png"
import rcs from "../Assets/rcs.png"
import weather from "../Assets/weather.png"
import portfolio from "../Assets/portfolio.png"


const ProjectDetails = () => {
  const projects = [
    {
      id: 1,
      title: "MarieMadeIt - E-commerce Website",
      description: "MarieMadeIt is an eCommerce website built to showcase and sell handmade crochet items, with a clean design, responsive layout, and integrated online payments.",
      image: marie,
      skills: ["React", "CSS", "JavaScript", "Node.js", "MongoDB", "Bootstrap", "Square API", "Admin Dashboard"],
      demoLink: "https://mariemadeit.com/",
      className: "card1"
    },
    {
      id: 2,
      title: "Rodgers Consulting Services - Business Website",
      description: "Rodgers Consulting Services Inc. provides personalized training and support to help consumers experience a more comfortable lifestyle with greater independence and strengthened abilities.",
      image: rcs,
      skills: ["React", "CSS", "JavaScript", "Bootstrap"],
      demoLink: "https://www.inficonsult.com/",
      className: "card2"
    },
    {
      id: 3,
      title: "Weather App - Weather Forecasting Application",
      description: "Weather app using API integration to display real-time conditions and forecasts in a responsive interface.",
      image: weather,
      skills: ["API Integration", "React", "CSS", "JavaScript"],
      demoLink: "https://weatherapp-arf.netlify.app/",
      className: "card3"
    },
    {
      id: 4,
      title: "Developer Portfolio - Interactive Project Showcase",
      description: "A personal developer portfolio showcasing my projects, skills, and experience, built with a responsive design and interactive UI elements to create a modern and engaging user experience.",
      image: portfolio,
      skills: ["React", "CSS", "JavaScript"],
      demoLink: "#",
      className: "card4"
    }
  ];

  return (
    <div className="projects">
        <h2 className='projects-title'>What I’ve Been Building</h2>
      {projects.map((project, index) => (
        <div key={project.id} className={`card ${project.className}`}>
          <div className='card-left'>
            <img src={project.image} alt={project.title} />
          </div>
          <div className='card-right'>
            <div className='title-skills'>
              <div className='project-info'>
                <h2>{project.title}</h2>
                <p>{project.description}</p>
              </div>
              <div className='project-skills'>
                {project.skills.map((skill, i) => (
                  <span key={i} className='skill-tag'>{skill}</span>
                ))}
              </div>
            </div>
            <div className='view-demo'>
              <a href={project.demoLink}>
                <h3>View Demo</h3>
              </a>
            </div>
          </div>
        </div>
      ))}
      <div className='view-more-container'>
        <Link to="/projects">
          <button className='view-more-btn'>View More</button>
        </Link>
      </div>
    </div>
  )
}

export default ProjectDetails